const positiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

export const shouldShowFavoriteControl = ({ settings = {}, user } = {}) =>
  Boolean(
    user &&
      Array.isArray(user.favorite_products) &&
      settings.user_favorite_product &&
      settings.user_favorite_product_staff,
  );

export const resolveMerchantTag = ({
  language = "english",
  product = {},
  settings = {},
  tags = [],
} = {}) => {
  if (
    !settings.enable_product_tag ||
    !settings.enable_product_tag_staff ||
    product.tag === null ||
    product.tag === undefined
  ) {
    return null;
  }
  const tag = (Array.isArray(tags) ? tags : []).find(
    ({ id }) => String(id) === String(product.tag),
  );
  if (!tag) return null;
  const label =
    language === "arabic"
      ? tag.text_ar || tag.text_en
      : tag.text_en || tag.text_ar;
  if (!label) return null;
  return {
    color: tag.color || "#555",
    label,
    placement: tag.placement === "down" ? "down" : "top",
  };
};

export const resolvePreparationTime = ({
  product = {},
  settings = {},
  surface,
} = {}) => {
  if (product.type_of_product === "service") {
    const minutes = positiveNumber(product.duration);
    if (!minutes) return null;

    // Grid historically honors both visibility switches; the other legacy
    // card renderers show service duration whenever it is present.
    if (
      surface === "grid" &&
      (!product.show_prep_time || !settings.show_prep_times)
    ) {
      return null;
    }
    return {
      minutes,
      onSelection: surface === "grid" && product.has_variants === true,
      type: "service",
    };
  }

  const minutes = positiveNumber(product.preparation_time);
  if (!minutes || !product.show_prep_time || !settings.show_prep_times) {
    return null;
  }
  return { minutes, onSelection: false, type: "preparation" };
};

export const resolveStockWarning = ({ availability, product = {} } = {}) => {
  const inventoryOnHand = Number(product.inventory_on_hand);
  const warningCount = Number(product.warning_item_availability_count);
  if (
    product.type_of_product !== "stocked" ||
    product.show_warning_item_availability !== true ||
    product.has_variants === true ||
    !availability?.available ||
    !Number.isFinite(inventoryOnHand) ||
    !Number.isFinite(warningCount) ||
    inventoryOnHand > warningCount
  ) {
    return null;
  }
  return {
    inventoryOnHand,
    messageValue: product.warning_item_availability_message_value,
  };
};
